import React from 'react';
import { parseIfJSON,
  replacePlaceholdersWithVariables, getCorrespondingScheme, replacePlaceholdersWithVariablesV2, getNestedValue2
 } from '../../utils/base';

 import Container from '../../components/Container';

import { NodeTypeScheme } from '../../types/base';

const ContainerTemplate: React.FC<NodeTypeScheme> = (obj) => {
  const {
    style: stDraft,
    events: eventsDraft,
    activeState: activeStateDraft,
    parentLoading,
    dataLake,
    pageSettings,
    settings,
    styleChunks,
    enableLocalShimmer,
    hash,
  } = obj || {};
    const { repeatable } = settings || {};
  const { source } = repeatable || {};

  if (!source) {
    return (
    <Container {...obj} />
  );
  }

  if (source) {
          const { activeState } = dataLake?.data ? replacePlaceholdersWithVariablesV2({ style: stDraft, events: eventsDraft, activeState: activeStateDraft }, dataLake.data) : { activeState: activeStateDraft };
          
          const replaced = dataLake?.data && typeof source === 'string' &&  /^{{this\..*}}$/.test(source) 
            ? getNestedValue2(dataLake.data, source.slice(7, -2)) // Remove '{{this.' and '}}'
            : replacePlaceholdersWithVariables(source, pageSettings?.variables);
            
          const parseSourceIfExist = parseIfJSON(replaced);

          if (Array.isArray(parseSourceIfExist)) {
            return parseSourceIfExist.map((sourceItem, sourceIndex) => {
              const dynamicProps = {
                dataLake: { data: parseSourceIfExist[sourceIndex] },
                parentIndex: sourceIndex,
                styleChunks,
                nestedTable: true,
                parentLoading: activeState === 'loading' || parentLoading,
                enableLocalShimmer,
              };
              return <Container key={`${obj.id}::${sourceIndex}`} {...obj} {...dynamicProps} hash={hash} />;
            });
          }
  }
};

export default ContainerTemplate;